import { create } from 'zustand';

/**
 * One crumb. `path` is optional: the entry for the page you are already on is not a link, which is
 * what distinguishes a trail you can navigate from a label that only restates where you are.
 */
export interface BreadcrumbOverrideEntry {
  label: string;
  path?: string;
}

/**
 * A page-supplied breadcrumb for the app header.
 *
 * `AuthenticatedHeader` builds its trail from a static path → crumbs table, which cannot express a
 * crumb whose text is loaded data — the ops dashboard's last crumb is the vehicle's plate, known
 * only once the quotation resolves. Rather than give that page its own second breadcrumb bar under
 * the real one, it pushes the trail up here and the header renders it in place of the table's.
 *
 * A page that sets it must clear it on unmount, or its trail outlives it on the next route.
 */
interface BreadcrumbState {
  override: BreadcrumbOverrideEntry[] | null;
  setBreadcrumbOverride: (entries: BreadcrumbOverrideEntry[] | null) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  override: null,
  setBreadcrumbOverride: (entries) => set({ override: entries }),
}));
